import React from 'react';
import CreditNoteForm from './CreditNoteForm';
import { useParams } from 'react-router-dom';

const EditCreditNotePage = () => {
    const { id } = useParams();
    return id ? <CreditNoteForm formType="edit" currentId={id} /> : <div>Loading...</div>;
};

export default EditCreditNotePage;